import React from 'react';

import {
  WrapperDiv,
  UserAvatarWrapperDiv,
  UserReviewOuterWrapperDiv,
  UserReviewWrapperDiv,
  UserDetailsAndRatingWrapperDiv,
  RowWithPadT10,
  UserNameStyle,
  AskedByStyle,
  UserReviewTextStyle,
} from './UserTaReview.styles';
import UserAvatar from '../UserAvatar/UserAvatar';
import {Column} from './../../common/Layouts/Layouts';

const UserTaReview = ({review}) => {
  const {
    tripType = '',
    reviewContent = '',
    ratingImageUrl = '',
    lastName = '',
    firstName = '',
  } = review;

  return (
    <>
      <WrapperDiv>
        <UserAvatarWrapperDiv>
          <UserAvatar firstName={firstName} lastName={lastName} />
        </UserAvatarWrapperDiv>

        <UserReviewOuterWrapperDiv>
          <Column>
            <UserDetailsAndRatingWrapperDiv>
              <Column>
                <RowWithPadT10>
                  <UserNameStyle>
                    {firstName} {lastName}
                  </UserNameStyle>
                </RowWithPadT10>
                <AskedByStyle>{tripType}</AskedByStyle>
              </Column>
              {ratingImageUrl && (
                <Column>
                  <img src={ratingImageUrl} />
                </Column>
              )}
            </UserDetailsAndRatingWrapperDiv>
            {reviewContent && reviewContent.length >= 0 && (
              <UserReviewWrapperDiv>
                <UserReviewTextStyle>{reviewContent}</UserReviewTextStyle>
              </UserReviewWrapperDiv>
            )}
          </Column>
        </UserReviewOuterWrapperDiv>
      </WrapperDiv>
    </>
  );
};

export default UserTaReview;
